<template>
    <AppPage title="Usuários" subtitle="Gerenciar os Usuários">

        <div class="actions" slot="actions">
            <b-input placeholder="Buscar" type="search" v-model="search"/>
        </div>

        <div class="products-list">
            <table class="table is-fullwidth is-striped is-hoverable is-middle">
                <thead>
                <tr>
                    <th>Nome</th>
                    <th class="is-hidden-touch">E-mail</th>
                    <th class="is-hidden-touch">Telefone</th>
                    <th width="50">Tipo</th>
                    <th width="10"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user in searchList" :key="user.id">
                    <td>{{ user.data.name }}</td>
                    <td class="is-hidden-touch">{{ user.data.email }}</td>
                    <td class="is-hidden-touch">{{ user.data.phone }}</td>
                    <td>
                        <b-tag v-if="user.data.accountType === 'client'">Cliente</b-tag>
                        <b-tag v-if="user.data.accountType === 'admin'" type="is-success">Administrador</b-tag>
                    </td>
                    <td>
                        <b-dropdown aria-role="list" position="is-bottom-left">
                            <button class="button is-text" slot="trigger" slot-scope="{ active }">
                                <b-icon :icon="active ? 'angle-up' : 'angle-down'"></b-icon>
                            </button>
                            <b-dropdown-item aria-role="listitem" @click="executeAction('editAccountType', user.id)">
                                Editar
                            </b-dropdown-item>
                        </b-dropdown>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </AppPage>
</template>

<script>
    import AppPage from "@/components/AppPage";
    import db from '@/services/database';
    import actions from '../users.actions';

    export default {
        name: "listUsers",
        components: {AppPage},

        data() {
            return {
                search: '',
                users: []
            }
        },

        methods: {
            executeAction(action, parameter) {
                const actionExecute = actions[action];
                if (actionExecute) {
                    actionExecute(parameter);
                }
            }
        },

        computed: {
            searchList() {
                const search = this.search.toLowerCase();
                return this.users.filter((user) => {
                    if (search) {
                        const {name, email} = user.data;
                        return name.toLowerCase().includes(search) || email.toLowerCase().includes(search);
                    }
                    return true;

                })
            }
        },

        created() {

            let loading = this.$buefy.loading.open();

            this._unsubscriveUsersSnapshots = db.collection('users')
                .orderBy('name')
                .onSnapshot((spapshot) => {
                    const users = []
                    spapshot.forEach(document => {
                        users.push({
                            id: document.id,
                            data: document.data()
                        });
                    });

                    this.users = users;

                    if (loading) {
                        loading.close();
                    }
                })
        },

        beforeDestroy() {
            if (this._unsubscriveUsersSnapshots) {
                this._unsubscriveUsersSnapshots();
            }
        }
    }
</script>
